module.exports = __webpack_public_path__ + "static/media/personal-icon.b1bf9d5f.svg";